/**
 * @typedef {import('antd').CheckboxProps} CheckboxProps
 */

import React from 'react';

import { Checkbox as CheckboxCore } from 'antd';

/**
 * @description UI Component to display checkbox. Underlying it is using the antd checkbox component.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @reference https://ant.design/components/checkbox
 *
 * @param {CheckboxProps}  props https://ant.design/components/date-picker
 * @returns {React.component}
 */

const Checkbox = (props) => {
	const { children = null } = props;
	return <CheckboxCore {...props}>{children}</CheckboxCore>;
};

export default Checkbox;
